import {useContext, useEffect, useState} from 'react'

import Context from '@s-ui/react-context'

import {getVehicleOverviewInfo} from './getVehicleOverviewInfo.js'

export const useVehicleOverviewInfo = ({specs}) => {
  const {domain, i18n} = useContext(Context)
  const [info, setInfo] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchVehicleInfo = async () => {
      if (specs) {
        setLoading(true)
        setError(null)
        try {
          const vehicleInfo = await getVehicleOverviewInfo({
            domain,
            i18n,
            makeId: specs.make.id,
            modelId: specs.model.id,
            makeSlug: specs.make.name,
            modelSlug: specs.model.name
          })
          setInfo(vehicleInfo)
        } catch (err) {
          console.error('Error fetching vehicle overview info:', err)
          setError(err)
        } finally {
          setLoading(false)
        }
      } else {
        setInfo(null)
        setError(null)
        setLoading(false)
      }
    }

    fetchVehicleInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specs])

  return {info, loading, error}
}
